import React from 'react';
import pkg from '../../package.json';

export const Version: React.FunctionComponent = (): React.ReactElement => {
    return <span>version: {pkg.version}</span>;
};
